<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav primary-background" fixedInViewport mode="over">
    <mat-toolbar class="sidenav-toolbar">
      @if (currentTenant(); as currentTenant) {
        @if (currentTenant.logoUrl; as logoUrl) {
          <logo logoTheme="white" [logoUrl]="logoUrl" />
        } @else {
          <div class="sitename-logo-alternative">{{ currentTenant.tenantName }}</div>
        }
      }
    </mat-toolbar>

    <mat-nav-list>
      <suvo-bi-list-navigation
        class="links-sidenav flex-1"
        [links]="links"
        showIcons="true"
        [borderRadius]="'0 24px 24px 0'"
        theme="inverted"
      />
    </mat-nav-list>
    <!-- <public-language-select /> -->

    <button mat-flat-button routerLink="/register" class="signup-button sidenav-button">
      Sign Up
    </button>
    <button mat-flat-button class="sidenav-button tertiary-background" routerLink="/login">
      <mat-icon>person</mat-icon>
      Login
    </button>
  </mat-sidenav>

  <mat-sidenav-content #sidenavContent class="middle-page">
    <mat-toolbar class="toolbar d-flex jc-between ai-center" color="primary">
      <div class="d-flex fd-row jc-start ai-center">
        <!-- TODO: Handle responsive show/hide with breakpoints -->
        <button
          class="hide show--lt-lg mobile-menu-button"
          mat-icon-button
          (click)="drawer.toggle()"
        >
          <mat-icon class="menu-icon">menu</mat-icon>
        </button>

        @if (currentTenant(); as currentTenant) {
          @if (currentTenant.logoUrl; as logoUrl) {
            <logo
              logoTheme="white"
              [logoUrl]="logoUrl"
              class="logo-margin home-link"
              (click)="homeClick()"
            />
          } @else {
            <div class="home-link" (click)="homeClick()">{{ currentTenant.tenantName }}</div>
          }
        }
      </div>

      <!-- TODO: Handle responsive show/hide with breakpoints -->
      <div class="hide--lt-lg">
        <nav class="nav-bar d-flex fd-row flex-1 jc-center ai-center gap-16">
          @for (link of links; track link.route) {
            <a
              class="link-button"
              mat-button
              expand
              [routerLink]="link.route"
              routerLinkActive="inactive-link active-link"
            >
              {{ link.displayName }}
            </a>
          }
        </nav>
      </div>

      <!-- <public-language-select /> -->

      <div class="bar-buttons-container d-flex fd-row jc-end ai-center">
        <div>
          <!-- TODO: Handle responsive show/hide with breakpoints -->
          <a class="link-button login-button hide--lt-sm" mat-button expand routerLink="/login">
            Log in
          </a>
          <button
            class="signup-button topright flex-1"
            mat-flat-button
            expand
            routerLink="/register"
          >
            SIGN UP
          </button>
        </div>
      </div>
    </mat-toolbar>

    <router-outlet />

    <public-footer [featureLinks]="links" />
  </mat-sidenav-content>
</mat-sidenav-container>
